














































import { computed, defineComponent, ref, useRoute, watch } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import { LoginFormFields } from './types';
import { duHost, duHostUsers, duProvisioning } from '~/utils/constants/hosts';
import TextInput from '~/components/Inputs/Text.vue';
import { EMAIL_PATTERN } from '~/utils/constants/code';
import { SfCheckbox } from '@storefront-ui/vue';
import { customerPasswordRegExp, invalidPasswordMsg } from '~/modules/customer/helpers/passwordValidation';
import { trackLogin } from '~/helpers/trackings/24orepro/user';

export default defineComponent({
  head() {
    return {
      script: [{ src: `${duProvisioning}/utenti/AuthFiles/SocialLogin/DUSocialLoginJS.ashx`, async: false, defer: false, body: true }]
    }
  },
  components: {
    TextInput,
    SfCheckbox,
  },
  props: {
    form: {
      type: Object as PropType<LoginFormFields>,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    }
  },
  setup(props) {
    const formCopy = ref<LoginFormFields>();
    const loginFormRef = ref(null);
    const route = useRoute(); 
    watch(() => props.form, (newForm) => { formCopy.value = { ...newForm }; }, { immediate: true, deep: true });

    const returnURL = computed(()=>{
      return `${location.origin}${route.value.fullPath}`
    });

    const isFormValid = computed(() => {
      const c = formCopy.value;
      return !!(
        c &&
        c.email && EMAIL_PATTERN.test(c.email) &&
        c.password && customerPasswordRegExp.test(c.password)
      );
    })

    return {
      formCopy,
      duHost,
      EMAIL_PATTERN,
      rememberMe: true,
      duHostUsers,
      returnURL,
      loginFormRef,
      customerPasswordRegExp,
      invalidPasswordMsg,
      isFormValid
    };
  },
  watch:{
    returnURL(newVal){
      this.formCopy.ERRURL=newVal
      this.formCopy.RURL=newVal
    }
  },
  methods: {
    onSubmit() {
      // @ts-ignore
      trackLogin(()=>this.loginFormRef.submit());      
    }
  }
});
